var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clientLogoUrl)?_c('img',{staticClass:"w-24",attrs:{"src":_vm.clientLogoUrl}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }